module.exports = __webpack_public_path__ + "img/1723688065352-makroni.jpg.c5b855a1.webp";